module.exports = __webpack_public_path__ + "static/media/alis01.b262f9d6.jpg";